import { Block } from 'webiq.boilerplate'

export default class CheckoutPaymentGiftcard extends Block {
	static title = 'checkout-payment-giftcard'

	init() {
        this.delete = this.getElement("delete")

        this.delete.addEventListener("click", () => {
            this.RemoveGiftcard(this.element.dataset.giftcard)
        })

		window.eventEmitter.on('paymentgiftcard:disable', () => {
			this.delete.classList.add('tw-pointer-events-none', 'tw-opacity-50')
		})

		window.eventEmitter.on('paymentgiftcard:enable', () => {
			this.delete.classList.remove('tw-pointer-events-none', 'tw-opacity-50')
		})
	}

    RemoveGiftcard($giftcard) {
		this.delete.querySelector('sl-spinner').classList.remove('tw-hidden')
		this.delete.classList.add('tw-pointer-events-none', 'tw-opacity-50')
		window.eventEmitter.emit('giftcardadd:disable')
        const payload = new FormData()
		payload.append('giftcard_token_id', $giftcard)
		payload.append('giftcard_remove', true)
		payload.append('ajax', true)

		fetch('/checkoutgiftcard', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then((response) => response.json())
			.then((json) => {
                if (json.error) {
					this.delete.querySelector('sl-spinner').classList.add('tw-hidden')
					this.delete.classList.remove('tw-pointer-events-none', 'tw-opacity-50')
                } else {
                    this.element.remove()
					window.eventEmitter.emit('total:refresh', json)
					window.eventEmitter.emit('giftcardadd:enable')
                }
			})
			.catch((error) => {
                console.log(error)
            })
    }
}
